import * as buffer from "buffer";
window.Buffer = buffer.Buffer;